import { noop } from 'underscore';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Button, makeStyles, tokens, Label } from '@fluentui/react-components';
import { BaseMessage } from '@bingads-webui/ads-copilot-ui';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const useReconnectCardStyles = makeStyles({
  root: {
    marginInline: tokens.spacingHorizontalXS,
    marginTop: tokens.spacingVerticalS,
    boxShadow: tokens.shadow2,
    marginBottom: tokens.spacingVerticalS,
  },
  label: {
    fontWeight: 'initial',
    padding: 'initial',
  },
  button: {
    marginTop: tokens.spacingVerticalS,
  },
});

export const ReconnectCard = React.memo(({ onClick = noop }) => {
  const i18n = React.useContext(I18nContext);
  const styles = useReconnectCardStyles();
  return (
    <BaseMessage
      className={styles.root}
      action={
        <Button
          appearance="secondary"
          size="small"
          onClick={onClick}
          aria-label="Connect to support"
          className={styles.button}
        >
          {i18n.getString(_TL_('Connect to support'))}
        </Button>
      }
    >
      <Label className={styles.label}>{i18n.getString(_TL_('If you have any other questions, feel free to reconnect to us.'))}</Label>
    </BaseMessage>
  );
});

ReconnectCard.propTypes = {
  onClick: PropTypes.func,
};

ReconnectCard.defaultProps = {
  onClick: noop,
};
